import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Upload } from "lucide-react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getCityName, getHubName, vehiclesDetails } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

const Createnewissues = ({ setActiveItem }) => {
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issuePriority;
  delete issuePriority?.inverted;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [activeStep, setActiveStep] = useState(0);
  const [form, setForm] = useState({});
  const [uploadedImages, setUploadedImages] = useState(null);
  const [cities, setCities] = useState({});
  const [hubs, setHubs] = useState({});
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [savedGenericData, setSavedGenericData] = useState(null);
  const [value, setValue] = useState("");

  const { quill, quillRef } = useQuill({
    theme: "snow",
    modules: {
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
    },
  });

  useEffect(() => {
    if (!quill) return;

    const onTextChange = () => {
      setForm((prev) => ({
        ...prev,
        description: quill.root.innerHTML,
      }));
    };

    quill.on("text-change", onTextChange);

    return () => {
      quill.off("text-change", onTextChange);
    };
  }, [quill]);

  const getCitiesAPI = async () => {
    const apiDetails = await getCityName();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setCities(data);
  };

  const getHubNameAPI = async (hubID) => {
    const apiDetails = await getHubName(hubID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows);
  };

  const getVehicleDetailsAPI = async (hubID) => {
    const apiDetails = await vehiclesDetails(hubID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleFilterListings(data?.entities?.rows);
  };

  useEffect(() => {
    getCitiesAPI();
  }, []);

  useEffect(() => {
    if (form?.city) {
      getHubNameAPI(form?.city);
    }
  }, [form?.city]);

  useEffect(() => {
    if (form?.hub) {
      getVehicleDetailsAPI(form?.hub);
    }
  }, [form?.hub]);

  const generalinformationfields = [
    {
      label: "City",
      value: "city",
      type: "dropdown",
      disabled: false,
      subCategory:
        cities &&
        Object.entries(cities).map(([key, value]) => ({
          value: value,
          label: key,
        })),
    },
    {
      label: "Hub",
      value: "hub",
      type: "dropdown",
      disabled: false,
      subCategory:
        hubs &&
        Object.entries(hubs).map(([id, item]) => ({
          value: item?.hubName,
          label: item?.id,
        })),
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "autocomplete",
      disabled: false,
    },
    {
      label: "Summary/Subject Line",
      value: "subjectline",
      type: "text",
      disabled: false,
    },
    {
      label: "Issue Type",
      value: "issuetype",
      type: "dropdown",
      disabled: false,
      subCategory:
        issueType &&
        Object.entries(issueType).map(([key, value]) => ({
          value: value,
          label: key,
        })),
    },
    {
      label: "issue Priority",
      value: "issuepriority",
      type: "dropdown",
      disabled: false,
      subCategory:
        issuePriority &&
        Object.entries(issuePriority).map(([key, value]) => ({
          value: value,
          label: key,
        })),
    },
    {
      label: "Start Odometer (KM)",
      value: "startodometer",
      type: "text",
      disabled: false,
    },
    {
      label: "Odometer Attachment",
      value: "odometerattachment",
      type: "file",
      disabled: false,
    },
    {
      label: "Other Attachment",
      value: "otherattachment",
      type: "file",
      disabled: false,
    },
    {
      label: "Description",
      value: "description",
      type: "quill",
      disabled: false,
    },
  ];

  const addReporterDetails = [
    {
      label: "Reporter Type",
      value: "reportertype",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "qa", value: "QA" },
        { key: "customer", value: "Customer" },
        { key: "fleet", value: "Fleet" },
      ],
    },
    {
      label: "Reporter Name",
      value: "reportername",
      type: "text",
      disabled: false,
      subCategory: [
        { key: "cash", value: "Cash" },
        { key: "cheque", value: "Cheque" },
        { key: "credit card", value: "Credit Card" },
        { key: "debit card", value: "Debit Card" },
        { key: "net banking", value: "Net Banking" },
        { key: "upi", value: "UPI" },
      ],
    },
    {
      label: "Reporter Email",
      value: "reporteremail",
      type: "text",
      disabled: false,
    },
    {
      label: "Reporter Mobile",
      value: "reportermobile",
      type: "text",
      disabled: false,
    },
    {
      label: "Booking Id",
      value: "bookingid",
      type: "text",
      disabled: false,
    },
  ];

  const steps = [
    {
      label: "General Information",
      description: (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 bg-white p-4 rounded-lg">
            {generalinformationfields.map((field, index) => (
              <>
                <div key={index} className="group">
                  <label className="block mb-2 font-semibold text-gray-700 text-sm">
                    {field.label}
                    {field.required && (
                      <span className="text-red-500 ml-1">*</span>
                    )}
                  </label>

                  {field.type === "dropdown" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      className="transition-all duration-200 hover:shadow-md"
                    >
                      <InputLabel id={`drop-label-${index}`}>
                        {field?.label}
                      </InputLabel>
                      <Select
                        labelId={`drop-label-${index}`}
                        value={form[field.value] || ""}
                        onChange={(e) =>
                          handleChange(field.value, e.target.value)
                        }
                        label={field?.label}
                        sx={{
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e5e7eb",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#818cf8",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6366f1",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 240,
                              borderRadius: "8px",
                              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        {field?.subCategory
                          ?.filter((opt) => opt.item !== "inverted") // optional safety
                          .map((option, idx) => (
                            <MenuItem
                              key={idx}
                              value={option.key ?? option.label ?? option.value}
                            >
                              {option.value}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  ) : field.type === "file" ? (
                    <div className="space-y-3">
                      <div className="relative">
                        <input
                          disabled={field.disabled}
                          type="file"
                          id={`file-${index}`}
                          multiple
                          onChange={(e) =>
                            handleChange(field.value, e.target.files)
                          }
                          className="hidden"
                          accept="image/*"
                        />
                        <label
                          htmlFor={`file-${index}`}
                          className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                            field.disabled
                              ? "bg-gray-100 cursor-not-allowed"
                              : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                          }`}
                        >
                          <Upload size={20} className="text-indigo-600" />
                          <span className="text-sm text-gray-600">
                            {form[field.value] ? "Change file" : "Upload file"}
                          </span>
                        </label>
                      </div>
                      {/* {form[field.value] && (
                          <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                            <img
                              src={
                                form[field.value].Location ||
                                form[field.value].path ||
                                form[field.value].url
                              }
                              className="w-full h-32 object-cover"
                              alt="Preview"
                            />
                            <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                              <Check size={16} />
                            </div>
                          </div>
                        )} */}
                    </div>
                  ) : field?.type === "autocomplete" ? (
                    <Autocomplete
                      disablePortal
                      options={vehicleFilterListings}
                      value={selectedVehicle}
                      onChange={(e, value) => setSelectedVehicle(value)}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => option.name || ""}
                      sx={{ width: 420 }}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          <div className="flex flex-col">
                            <span className="font-medium">
                              {option.name} – {option.licensePlate}
                            </span>
                            <span className="text-xs text-gray-500">
                              {option.cityText} • {option.vehicleGroupText}
                            </span>
                          </div>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} label="Vehicle" size="small" />
                      )}
                    />
                  ) : field?.type === "quill" ? (
                    <div className="w-full md:w-[1300px]">
                      <div ref={quillRef} />
                    </div>
                  ) : (
                    <input
                      disabled={field.disabled}
                      type={field.type}
                      value={form[field.value] || ""}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                        field.disabled
                          ? "bg-gray-100 cursor-not-allowed"
                          : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                      } outline-none`}
                      placeholder={`Enter ${field.label.toLowerCase()}`}
                    />
                  )}
                </div>
              </>
            ))}
          </div>

          {uploadedImages && (
            <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
              {uploadedImages?.length > 0 ? (
                <div className="mt-6 flex gap-4 flex-wrap">
                  {uploadedImages.map((image, index) => (
                    <img
                      key={index}
                      src={
                        image?.url || image?.Location || image?.path || image
                      }
                      alt="Image Preview"
                      className="w-44 h-44 rounded-lg object-cover border shadow"
                    />
                  ))}
                </div>
              ) : (
                <div className="mt-6 flex gap-4 flex-wrap">
                  <img
                    src={uploadedImages}
                    alt="Image Preview"
                    className="w-44 h-44 rounded-lg object-cover border shadow"
                  />
                </div>
              )}
            </div>
          )}
        </>
      ),
    },
    {
      label: "Reporter and Booking Detail",
      description: (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 bg-white p-4 rounded-lg">
            {addReporterDetails.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {field.type === "dropdown" ? (
                  <FormControl
                    fullWidth
                    size="small"
                    className="transition-all duration-200 hover:shadow-md"
                  >
                    <InputLabel id={`drop-label-${index}`}>
                      {field?.label}
                    </InputLabel>
                    <Select
                      labelId={`drop-label-${index}`}
                      value={form[field.value] || ""}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      label={field?.label}
                      sx={{
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#818cf8",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted") // optional safety
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : field.type === "file" ? (
                  <div className="space-y-3">
                    <div className="relative">
                      <input
                        disabled={field.disabled}
                        type="file"
                        id={`file-${index}`}
                        multiple
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                        className="hidden"
                        accept="image/*"
                      />
                      <label
                        htmlFor={`file-${index}`}
                        className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                          field.disabled
                            ? "bg-gray-100 cursor-not-allowed"
                            : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                        }`}
                      >
                        <Upload size={20} className="text-indigo-600" />
                        <span className="text-sm text-gray-600">
                          {form[field.value] ? "Change file" : "Upload file"}
                        </span>
                      </label>
                    </div>
                    {/* {form[field.value] && (
                          <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                            <img
                              src={
                                form[field.value].Location ||
                                form[field.value].path ||
                                form[field.value].url
                              }
                              className="w-full h-32 object-cover"
                              alt="Preview"
                            />
                            <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                              <Check size={16} />
                            </div>
                          </div>
                        )} */}
                  </div>
                ) : (
                  <input
                    disabled={field.disabled}
                    type={field.type}
                    value={form[field.value] || ""}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                      field.disabled
                        ? "bg-gray-100 cursor-not-allowed"
                        : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                    } outline-none`}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                  />
                )}
              </div>
            ))}
          </div>
        </>
      ),
    },
  ];

  const handleChange = async (field, value) => {
    if (field === "odometerattachment" || field === "otherattachment") {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({
          ...prev,
          [field]: res?.uploaded || "",
        }));
      });
    } else {
      setForm((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validationRulesForGeneric = {
    // subjectline: {
    //   regex: /^.{5,100}$/,
    //   message: "Summary must be between 5 and 100 characters",
    // },
    startodometer: {
      regex: /^[0-9]{1,7}$/,
      message: "Odometer must be a valid number",
    },
    issuetype: {
      regex: /^[0-9]+$/,
      message: "Issue type is required",
    },
    issuepriority: {
      regex: /^[0-9]+$/,
      message: "Priority is required",
    },    
  };

  const validationRulesForReporting = {
    reportertype: {
      regex: /^(?!\s*$).+/,
      message: "Reporter type is required",
    },
    reportername: {
      regex: /^[A-Za-z\s]{3,50}$/,
      message: "Reporter name must be at least 3 characters",
    },
    reporteremail: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Please enter a valid email address",
    },
    reportermobile: {
      regex: /^\d{10}$/,
      message: "Please enter a valid 10-digit mobile number",
    },
  };

  const validateFormGeneric = (form) => {
    for (const field in validationRulesForGeneric) {
      const value = form?.[field];

      if (
        !value ||
        !validationRulesForGeneric[field].regex.test(String(value))
      ) {
        toast.error(validationRulesForGeneric[field].message);
        return false;
      }
    }
    return true;
  };

  const validateFormForReporting = (form) => {
    for (const field in validationRulesForReporting) {
      const value = form?.[field]?.toString().trim();

      if (!value) {
        toast.error(validationRulesForReporting[field].message);
        return false;
      }

      if (!validationRulesForReporting[field].regex.test(value)) {
        toast.error(validationRulesForReporting[field].message);
        return false;
      }
    }

    return true;
  };

  const updateGenericDetails = async () => {
    if (!validateFormGeneric(form)) return;
    let hubTextval = hubs?.filter((item) => item?.id === form?.hub)?.hubName;
    try {
      const response = await fetch(`${apiUrl}/api/vehicleissues`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          vehicleId: selectedVehicle?.id,
          vehicleName: selectedVehicle?.name,
          vehicleRegistration: selectedVehicle?.licensePlate,
          cityText: selectedVehicle?.cityText,
          cityId: selectedVehicle?.cityId,
          odometerReading: form?.startodometer,
          odometerImage: JSON.stringify(form?.odometerattachment),
          summary: form?.subjectline,
          description: form?.description,
          issueType: form?.issuetype,
          priorityId: form?.issuepriority,
          hubId: form?.hub,
          hubText: hubTextval,
          issueImages: JSON.stringify(form?.otherattachment),
          reportingOdometerReading: form?.startodometer,
          reportedDate: new Date(),
          status: issueStatus?.inverted?.open,
          odometerImages: JSON.stringify(form?.odometerattachment),
          priority: form?.issuepriority,
          type: form?.issuetype,
          imageList: [
            {
              vehicleId: selectedVehicle?.id,
              attachments: JSON.stringify(form?.otherattachment),
              imageFor: "preFixed",
            },
          ],
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setSavedGenericData(data?.dataValues);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        toast.success("Generic Details Updated successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const updateReporterDetails = async () => {
    if (!validateFormForReporting(form)) return;
    try {
      const response = await fetch(`${apiUrl}/api/vehicleissues`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          reporterType: form?.reportertype,
          reporterName: form?.reportername,
          reporterEmail: form?.reporteremail,
          reporterMobile: form?.reportermobile,
          bookingCode: form?.bookingid,
          id: savedGenericData?.id,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("New issue created successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setActiveItem("View all Issues");
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleNext = async (type) => {
    if (type === "Save and Continue Editing") {
      await updateGenericDetails();
    } else if (type === "Finish") {
      await updateReporterDetails();
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  return (
    <>
      <Box sx={{ p: { xs: 2, md: 5 } }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel
                optional={
                  index === steps.length - 1 ? (
                    <Typography variant="caption">Last step</Typography>
                  ) : null
                }
              >
                {step.label}
              </StepLabel>
              <StepContent>
                <Typography>{step.description}</Typography>
                <Box
                  sx={{
                    mb: 2,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() =>
                      handleNext(
                        index === steps.length - 1
                          ? "Finish"
                          : "Save and Continue Editing"
                      )
                    }
                    sx={{ mt: 1 }}
                  >
                    {index === steps.length - 1
                      ? "Finish"
                      : "Save and Continue Editing"}
                  </Button>

                  <Button
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1 }}
                  >
                    Back
                  </Button>
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
        {activeStep === steps.length && (
          <Paper square elevation={0} sx={{ p: 3 }}>
            <Typography>All steps completed - you&apos;re finished</Typography>
            <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
              Reset
            </Button>
          </Paper>
        )}
      </Box>
    </>
  );
};

export default Createnewissues;
